module.exports = __webpack_public_path__ + "data/navigation-sensors-and-connectors.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/navigation/navigation-sensors-and-connectors.json
// module id = jGr0
// module chunks = 1